import SpriteSymbol from "../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "svg-star1",
  "use": "svg-star1-usage",
  "viewBox": "0 0 27.482 27.482",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 27.482 27.482\" fill=\"currentColor\" id=\"svg-star1\"><g transform=\"translate(-139.01 -68.994)\"><path d=\"m166.22 82.735-8.7047 4.7608-4.7608 8.7047-4.7608-8.7047-8.7047-4.7608 8.7047-4.7608 4.7608-8.7047 4.7608 8.7047z\" /></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol